import React from "react";
import { PageLayout } from "components/layout/PageLayout";
import Educations from "containers/education/Educations";
import Certifications from "containers/certifications/Certifications";
import EducationImg from "./EducationImg";
import PageHero from "components/pageHero/PageHero";
import { certifications, degrees } from "portfolio";
import type { ThemeWithOptionalSetterProps } from "types";

const Education: React.FC<ThemeWithOptionalSetterProps> = (props) => {
  const theme = props.theme;
  const educationStats = [
    {
      label: "Academic Programs",
      value: `${degrees.degrees.length}`,
      accent: "var(--accent)",
    },
    {
      label: "Certifications",
      value: `${certifications.certifications.length}`,
      accent: "var(--accent-cool)",
    },
    {
      label: "Current Focus",
      value: "AI + Software Engineering",
      accent: "var(--accent-warm)",
    },
  ];

  return (
    <PageLayout theme={theme} setTheme={props.setTheme}>
      <PageHero
        eyebrow="Learning Journey"
        title="Education"
        subtitle="Academic foundation and certifications"
        description="I actively participate in hackathons and other tech-related activities. Below are some of my major certifications and academic milestones."
        highlights={["Computer Science", "Hackathons", "Continuous learning"]}
        media={<EducationImg theme={theme} />}
      />
      <section className="mt-10 grid gap-3 sm:grid-cols-3">
        {educationStats.map((stat) => (
          <div
            key={stat.label}
            className="relative overflow-hidden rounded-lg border border-border bg-bg-elevated/70 px-4 py-4"
          >
            <div
              className="absolute inset-x-0 top-0 h-0.5"
              style={{
                background: `linear-gradient(90deg, ${stat.accent}, transparent)`,
              }}
            />
            <p className="font-mono text-[10px] uppercase tracking-[0.14em] text-text-muted">
              {stat.label}
            </p>
            <p className="mt-2 text-sm font-semibold leading-snug tracking-normal text-text-primary">
              {stat.value}
            </p>
          </div>
        ))}
      </section>
      <Educations />
      <Certifications />
    </PageLayout>
  );
};

export default Education;
